import { createContext } from 'react';
import type { Tracking } from '@/lib/heap/trackingAttributes';

export interface BackButtonConfig {
    text?: string;
    variant: 'wide' | 'narrow';
    confirmTitle?: string;
    confirmSubtitle?: string;
    confirmMessage?: string;
    confirmButtonText?: string;
    cancelButtonText?: string;
    onBack?: () => void;
    tracking?: Tracking;
}

export interface LayoutContextType {
    showFooter: boolean;
    setShowFooter: (show: boolean) => void;
    backButton: BackButtonConfig | undefined;
    setBackButton: (config: BackButtonConfig | undefined) => void;
    /** Fills the main column (below the header, including the back row) so it matches page shells like SidebarLayout. */
    mainContentBackgroundClass: string | undefined;
    setMainContentBackgroundClass: (className: string | undefined) => void;
}

export const LayoutContext = createContext<LayoutContextType | undefined>(undefined);
